// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file CurvePoint.proto (package CurvePoint, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file CurvePoint.proto.
 */
export const file_CurvePoint: GenFile = /*@__PURE__*/
  fileDesc("ChBDdXJ2ZVBvaW50LnByb3RvEgpDdXJ2ZVBvaW50IjEKCkN1cnZlUG9pbnQSEAoIbGF0aXR1ZGUYASABKAESEQoJbG9uZ2l0dWRlGAIgASgBQkAKLWNvbS5nbXYuZGVtZXRlci5uYXZhaWRzLm1vZGVsLnByb3RvLmdlbmVyYXRlZEIPQ3VydmVQb2ludFByb3RvYgZwcm90bzM");

/**
 * @generated from message CurvePoint.CurvePoint
 */
export type CurvePoint = Message<"CurvePoint.CurvePoint"> & {
  /**
   * @generated from field: double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 2;
   */
  longitude: number;
};

/**
 * Describes the message CurvePoint.CurvePoint.
 * Use `create(CurvePointSchema)` to create a new message.
 */
export const CurvePointSchema: GenMessage<CurvePoint> = /*@__PURE__*/
  messageDesc(file_CurvePoint, 0);

